import { render, staticRenderFns } from "./DocumentTypeAutocomplete.vue?vue&type=template&id=4c8fd078"
import script from "./DocumentTypeAutocomplete.vue?vue&type=script&lang=js"
export * from "./DocumentTypeAutocomplete.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports